import React from 'react'

function CompanyName() {
    const CompanyName = "Gotenberg Solution"


    return (
        <>
            <span aria-label="Gotenberg Solution" title='Gotenberg Solution'>{CompanyName}</span>


        </>
    )
}

export default CompanyName